
import 'babel-polyfill'

import Vue from 'vue'
import vuetify from '@/plugins/vuetify'
import VueI18n from 'vue-i18n'

import App from './App.vue'
import store from './store.js'
import vueRouter from 'vue-router'
import interceptor from './helpers/interceptor'

import VueRouter from 'vue-router'

import translations from './i18n/translation.json'
import dateformats from './i18n/dateformats.json'
import './registerServiceWorker'

import VueAppInsights from 'vue-application-insights'
import VueGtag from "vue-gtag";

import config from './configuration.json'
import routeConfig from './routes'

Vue.use(vueRouter)

const routes = routeConfig;

const router = new VueRouter({ routes, mode: 'history' })

Vue.use(VueAppInsights, {
  id: config.appInsightsInstrumentKey,
  router
});

Vue.use(VueGtag, {
  config: { id: config.googleTrackingCode },
  appName: "Data to the customer",
  pageTrackerScreenviewEnabled: true
}, router);

Vue.config.productionTip = false

interceptor(store, router);

const dateTimeFormats = dateformats;

// Setup translation service
const i18n = new VueI18n({
  locale: store.getters.language,
  fallbackLocale: 'en',
  messages: translations,
  dateTimeFormats
})

/**
 * Check permissions before executing the routing
 */
router.beforeEach((to, from, next) => {
  //check if the route requires a authenticated user
  if (to.matched.some(route => route.meta.requiresAuth)) {
    //if the user is not even authenticated, redirect to login
    if (!store.getters.authenticated) {
      sessionStorage.setItem("originalRoute", to.fullPath);
      store.dispatch("loginWithSchottId");
    }
    else {
      //get the scope of the user
      let userscopes = store.getters.scopes;
      //variable that holds the status
      let permission = false;

      //allow access if the route is not protected with scopes.
      //this means the route needs a authentication user, but don't specify the type of the user
      if (to.meta.scopes == undefined) {
        permission = true;
      }
      else {
        /**
         * iterate over the required scopes and check if the user has this permission
         */
        to.meta.scopes.forEach(scope => {
          if (userscopes.includes(scope)) {
            permission = true;
            return true;
          }
        });
      }

      // if permission is there, execute the route
      if (permission === true) {
        return next();
      }
      //without permission, the route /403 is triggered
      else {
        return next('/403');
      }
    }
  }
  //if no permission is required, execute the route.
  next();
});



new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
